import i18n from "config/i18next";

i18n.addResources("es", "pdf", {
  dragging: "Soltá acá tu archivo",
  instruction: "O arrastrá y soltá el archivo",
});
